import { t } from '@lingui/macro'
import { useDmpConnectDcParameter } from '../model/useDmpConnectDcParameter'
import { DmpConnectLoading } from './DmpConnectLoading'
import { DmpConnectError } from './DmpConnectError'

export function DmpConnectDcParameter({ children }: { children: React.ReactNode }) {
  const { error, isLoadingDcParameter } = useDmpConnectDcParameter()

  if (error) {
    return <DmpConnectError error={error} />
  }

  if (isLoadingDcParameter) {
    return <DmpConnectLoading message={t`Initializing DMP Connect`} />
  }

  return <>{children}</>
}
